/**
 * 发票类型
 */
enum InvoiceType {
    专票 = 'VAT_SPECIAL_INVOICE',
    普票 = 'VAT_INVOICE',
    机票 = 'VAT_SPECIAL_INVOICE_MOTORVEHICLE',
    电票 = 'VAT_INVOICE_ELECTRONIC',
    卷票 = 'VAT_INVOICE_VOLUME',
    货票 = 'VAT_SPECIAL_INVOICE_TRANSPORTATION',
    通票 = 'VAT_INVOICE_TOLL',
    二手车票 = 'VAT_INVOICE_USED_CAR',
}
export default InvoiceType;



// WEBPACK FOOTER //
// ./src/node_modules/kts-platform-frame/entry/constant/InvoiceType/index.ts